mutation UpdatePracticeRecording($id: ID!, $shared: Boolean, $notes: String) {
  updatePracticeRecording(id: $id, shared: $shared, notes: $notes) {
    ok
    errors
  }
}
